export { GolfTeeTimesContent } from './GolfTeeTimesContent';
export type {
  GolfTeeTimeOption,
  GolfTeeTimesContentLabels,
  GolfTeeTimesContentProps,
} from './GolfTeeTimesContent.types';
